// 画面ロード時に .js-load-show に .show クラスを追加
window.addEventListener('load', function () {
  const loadElements = document.querySelectorAll('.js-load-show');
  loadElements.forEach(el => {
    el.classList.add('show');
  });

});

// スクロール時に .scroll-in に .show クラスを追加
window.addEventListener('scroll', function () {
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;
  const triggerPosition = windowHeight * 0.8;

  const boxes = document.querySelectorAll('.scroll-in');

  boxes.forEach(function (box) {
    const distanceToBox = box.getBoundingClientRect().top; // 要素の上端位置
    if (distanceToBox < triggerPosition) {
      box.classList.add('show');
    }
  });

  const target = document.querySelector('.lp-20250401-content__layout__left');
  const windowWidth = window.innerWidth;

  if (!target) return;

  if (windowWidth >= 768 && scroll >= 85) {
    target.classList.add('top-custom');
  } else {
    target.classList.remove('top-custom');
  }
});


const links = document.querySelectorAll('a[href^="#"]');

links.forEach((link) =>{
  link.addEventListener('click', (e) => {
    e.preventDefault();
    
    const href = link.getAttribute('href');
    const targetSection = document.querySelector(href);
    const sectionTop = targetSection.getBoundingClientRect().top;
    const currentPos = window.scrollY;
    const gap = 84;
    const target = sectionTop + currentPos - gap;

    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
});

const swiper = new Swiper(".parts_swiper", {
  loop: true, // ループ有効
  slidesPerView: 6.5, // 一度に表示する枚数
  speed: 5000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  spaceBetween: 10,
  autoplay: {
    delay: 0, // 途切れなくループ
    disableOnInteraction: false,

  },
});

// typing
